import {Component, OnInit, TemplateRef} from "@angular/core";
import {Router} from "@angular/router";
import {User} from "../../../models/user.model";
import {ENVIRONMENT} from "../../../../environments/environment";
import {HelperService} from "../../../services/helperService";
import {HttpParams} from "@angular/common/http";
import {DetailService} from "../../../services/details/detail.service";
import {Ng4LoadingSpinnerService} from "ng4-loading-spinner";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import { SelectItem} from "ng2-select-compat";
import {UsersService} from "../../../services";
import {ToastrService} from "ngx-toastr";
import {TranslateService} from "@ngx-translate/core";
import {BsModalRef, BsModalService} from "ngx-bootstrap/modal";

@Component({
	selector: "tig-client-selection",
	templateUrl: "./client-selection.component.html",
	styleUrls: ["./client-selection.component.css"],
})
/**
 * Class > ClientSelectionComponent
 */
export class ClientSelectionComponent implements OnInit
{


	/**
	 * Attributes
	 */
	public STR_company: string;
	public OBJ_current_user: User;
	public OBJ_dt_options: DataTables.Settings = {};
	public ARR_clients = [];
	private OBJ_modal_reference: BsModalRef;
	private OBJ_modal_options = ENVIRONMENT.modal_options;
	public OBJ_form_group: FormGroup;
	public OBJ_config;

	/**
	 * Function > constructor
	 * @param {Router} OBJ_router
	 * @param {HelperService} OBJ_helper_service
	 * @param OBJ_modal_service
	 * @param OBJ_detail_service
	 * @param OBJ_loading_spinner
	 * @param OBJ_form_builder
	 * @param OBJ_user_service
	 * @param OBJ_toastr_service
	 * @param OBJ_translate_service
	 */
	constructor
	(
		private OBJ_router: Router,
		private OBJ_helper_service: HelperService,
		private OBJ_modal_service: BsModalService,
		private OBJ_detail_service: DetailService,
		private OBJ_loading_spinner: Ng4LoadingSpinnerService,
		private OBJ_form_builder: FormBuilder,
		private OBJ_user_service: UsersService,
		private OBJ_toastr_service: ToastrService,
		private OBJ_translate_service: TranslateService
	)
	{

        // get company string
        this.OBJ_config = this.OBJ_helper_service.getFromLocalstorage('config');
        this.STR_company = this.OBJ_config.company;

        // get current user
		this.OBJ_current_user = this.OBJ_helper_service.getFromLocalstorage('current_user');
		this.fillTableWithData();
	} // end function constructor


	/**
	 * Function > ngOnInit
	 */
	ngOnInit() {} // end function ngOnInit


	/**
	 * Function > fillTableWithData
	 * @desc Konfiguration der Tabelle
	 */
	fillTableWithData()
	{

		// Attribute
		let ARR_columns_config = [
			{
				data: "name",
				title: "Title"
			}
		];

		let ARR_clients = [];
        this.OBJ_current_user.clients.forEach((OBJ_item) => {
        	let OBJ_clone =  Object.assign({}, OBJ_item);
        	if (OBJ_clone.logo) {
				OBJ_clone.name = "<img alt='image' class='img-circle tig-logo' src='" + OBJ_clone.logo + "' /> " + OBJ_clone.name;
			} else {
				OBJ_clone.name = "<div class='img-circle tig-logo'>" + this.OBJ_helper_service.getInitials(OBJ_clone.name) + "</div>" + OBJ_clone.name;
			} // end if
			ARR_clients.push(OBJ_clone);
		});

		this.OBJ_dt_options = {
			data: ARR_clients,
			columns: ARR_columns_config,
			order: [[0, "asc"]],
			paging: false,
			info: false,
			// searching: false,
			// click event for the row
			rowCallback: (OBJ_row: Node, OBJ_data) =>
			{

				$(OBJ_row).on("click", (OBJ_event) => {
					this.rowClickHandler(OBJ_data);
				});

			} // end function rowCallback
		};

	} // end fillTableWithData


	/**
	 * Function > rowClickHandler
	 * @desc Change WCMS domain
	 * @param {object} OBJ_data
	 * @return void
	 */
	rowClickHandler(OBJ_data: any): void
	{

		let STR_url = OBJ_data.webaddress;

		// Non-Production-Environments have slightly different url
		if(ENVIRONMENT.env !== 'production')
		{
			// if www is set (not always the case) delete it
			STR_url = STR_url.replace('www', '');

			// url sometimes starts with a subdomain other than www
			if(!STR_url.startsWith("."))
			{
				STR_url = "." + STR_url;
			} // end if

			// append environment subdomain (usually dev or preview) and port
			STR_url = ENVIRONMENT.location.subdomain + STR_url + (ENVIRONMENT.env === 'development' ? ':' + window.location.port : '');
		}

		 STR_url = window.location.protocol + '//' + STR_url + '/wcms/login?token=' + this.OBJ_helper_service.getFromLocalstorage('access', true, true);

		this.OBJ_helper_service.logWithClassAndFunction("ClientSelectionComponent", "rowClickHandler", STR_url);

		// redirect to url
		location.assign(STR_url);

	} // end function rowClickHandler

	/**
	 * Function > requestAccess
	 * @desc send data to backend
	 */
	requestAccess()
	{

		if(this.OBJ_form_group.valid)
		{
			let OBJ_form_control = this.OBJ_form_group.get("clients");
			let ARR_selected_clients: Array<SelectItem> = OBJ_form_control.value;
			let ARR_client_ids = [];
			for (let OBJ_client of ARR_selected_clients)
			{
				ARR_client_ids.push(OBJ_client.id);
			} // end for

			// buold data for backend
			let OBJ_data:any = {
				"clients" : ARR_client_ids,
				"message" :  this.OBJ_form_group.get("message").value
			};

			// give user guestaccess to requested clients
			this.OBJ_user_service.addGustRoles("/api/wcms/addguestroles", OBJ_data).subscribe(
				value => {
					// output success
					this.OBJ_toastr_service.success(this.OBJ_translate_service.instant("oClientSelection.sAddedRoles"));
					this.hideModal();
				}
			);

		} // end if

	} // end function requestAccess


	/**
	 * Function > hideModal
	 * @return {void}
	 */
	hideModal(): void
	{
		this.OBJ_modal_reference.hide();
	} // end function hideModal

} // end class ClientSelectionComponent
